function getBase(state) {
  return state.data.colorSchemes
}

export function getColorScheme(state, props) {
  const { colorSchemeId } = props
  const colorSchemeIdString = colorSchemeId.toString()
  return getBase(state).entities[colorSchemeIdString]
}

export function getCurrentColorScheme(state) {
  const colorSchemeOrIdentifier = getBase(state).current
  if (typeof colorSchemeOrIdentifier === 'string' || typeof colorSchemeOrIdentifier === 'number') {
    return getColorScheme(state, { colorSchemeId: colorSchemeOrIdentifier })
  } else {
    return colorSchemeOrIdentifier
  }
}

export function getEditableColorScheme(state) {
  return getBase(state).editable
}
